export default __webpack_public_path__ + "static/media/9-qa-automatico.8f79772f.png";